import {Injectable} from "@angular/core";
import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";import {
    LovValueSummaryConverter
} from "../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {TreatmentJourneyStepDefinitionTriggerModel} from "./treatmentJourneyStepDefinitionTrigger.model";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepDefinitionTriggerConverter extends HttpModelConverter<TreatmentJourneyStepDefinitionTriggerModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyStepDefinitionTriggerModel {
        return new TreatmentJourneyStepDefinitionTriggerModel();
    }

    protected enrichObject(result: TreatmentJourneyStepDefinitionTriggerModel, src: TreatmentJourneyStepDefinitionTriggerModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
    }


}